export default __webpack_public_path__ + "static/media/khaled.306342da.png";